export default __webpack_public_path__ + "static/media/lipstick4.551a9d8a.jpg";